import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { AsyncDropdown } from '@ami/react/core';
import industriesService from './industriesService';
import { IndustryFilter } from '../industries/industryFilter';

export class IndustriesAsyncDropdown extends Component {
  constructor(props) {
    super(props);
    this.getAsyncForDropDown = this.getAsyncForDropDown.bind(this);
  }
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    selected: PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
    placeholder: PropTypes.string,
    carrierId: PropTypes.string,
    weightCategoryId: PropTypes.string,
    addNotSpecifiedOption: PropTypes.bool,
  };
  async getAsyncForDropDown(name) {
    const { carrierId, weightCategoryId, addNotSpecifiedOption } = this.props;
    var industries = (
      await industriesService.search(
        new IndustryFilter({ name, carrierId, weightCategoryId })
      )
    ).map((x) => ({
      id: x.id,
      label: x.name,
    }));

    if (addNotSpecifiedOption) {
      industries.push({
        id: 'NOT_SPECIFIED',
        label: 'Not Specified',
      });
    }

    return industries;
  }
  render() {
    const { placeholder, ...rest } = this.props;
    return (
      <AsyncDropdown
        alwaysOnFocus={true}
        placeholder={placeholder ? placeholder : 'All'}
        isClearable={true}
        fetchItems={this.getAsyncForDropDown}
        prepopulateFromStorage={true}
        {...rest}
      />
    );
  }
}
